// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ResendVerificationEmail-__style___1d4K0","title":"app-pages-ResendVerificationEmail-__style___39wAz","left":"app-pages-ResendVerificationEmail-__style___2zu50","right":"app-pages-ResendVerificationEmail-__style___3HbYS","text-margin-resend":"app-pages-ResendVerificationEmail-__style___3jsJI"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/ResendVerificationEmail/style.css
// module id = 2507
// module chunks = 0